import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { PasswordStrengthValidator } from '../../models/password-strength.validators';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css'],
})
export class ResetPasswordComponent implements OnInit {
  ResponseResetForm: FormGroup;
  errorMessage: string;
  successMessage: string;
  resetToken: null;
  CurrentState: any;
  IsResetFormValid = true;
  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private errorDialogService: ErrorDialogService
  ) {
    this.CurrentState = 'Wait';
    this.route.params.subscribe(params => {
      this.resetToken = params.id;
    });
  }

  ngOnInit() {
    this.Init();
    this.Validate(this.ResponseResetForm);
  }

  setToken() {
    this.authService.saveTokens(this.resetToken);
  }

  Init() {
    this.ResponseResetForm = this.fb.group({
      resettoken: [this.resetToken],
      newPassword: ['', [Validators.required, Validators.minLength(8), PasswordStrengthValidator]],
      confirmPassword: [
        '',
        [Validators.required, Validators.minLength(8), PasswordStrengthValidator],
      ],
    });
  }

  Validate(passwordFormGroup: FormGroup) {
    const new_password = passwordFormGroup.controls.newPassword.value;
    const confirm_password = passwordFormGroup.controls.confirmPassword.value;

    if (confirm_password.length <= 0) {
      return null;
    }

    if (confirm_password !== new_password) {
      return {
        doesNotMatch: true,
      };
    }

    return null;
  }

  ResetPassword(form) {
    this.setToken();
    if (form.valid) {
      this.IsResetFormValid = true;

      const newPass = {
        password: this.ResponseResetForm.value.confirmPassword,
      };
      this.authService.createNewPassword(newPass).subscribe(
        () => {
          this.ResponseResetForm.reset();
          setTimeout(() => {
            this.successMessage = null;
            this.router.navigate(['login']);
            this.errorDialogService.openDialog('alert.passwordChanged', false);
            sessionStorage.clear();
          }, 3000);
        },
        err => {
          if (err.error.message) {
            this.errorMessage = err.error.message;
          }
        }
      );
    } else {
      this.IsResetFormValid = false;
    }
  }

  openLogin() {
    this.router.navigateByUrl('/');
  }
}
